module.exports = __webpack_public_path__ + "static/img/bg.9413fddc.png";